module.exports = __webpack_public_path__ + "media/images/pc/stores/karuizawa/karuizawa_concept_02-c665086f98a128f3c6812f71512dd230.jpg";